"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSignatureRequest = exports.UpdateSignatureRequest = void 0;
var UpdateSignatureRequest = /** @class */ (function () {
    function UpdateSignatureRequest(Name, ReplyToEmail, ReturnPathDomain, ConfirmationPersonalNote) {
        this.Name = Name;
        this.ReplyToEmail = ReplyToEmail;
        this.ReturnPathDomain = ReturnPathDomain;
        this.ConfirmationPersonalNote = ConfirmationPersonalNote;
    }
    return UpdateSignatureRequest;
}());
exports.UpdateSignatureRequest = UpdateSignatureRequest;
var CreateSignatureRequest = /** @class */ (function () {
    function CreateSignatureRequest(Name, FromEmail, ReplyToEmail, ReturnPathDomain, ConfirmationPersonalNote) {
        this.Name = Name;
        this.ReplyToEmail = ReplyToEmail;
        this.ReturnPathDomain = ReturnPathDomain;
        this.FromEmail = FromEmail;
        this.ConfirmationPersonalNote = ConfirmationPersonalNote;
    }
    return CreateSignatureRequest;
}());
exports.CreateSignatureRequest = CreateSignatureRequest;
//# sourceMappingURL=Signature.js.map